import { render } from "./XIconSolidPlug.vue?vue&type=template&id=10b7cdc4"
import script from "./XIconSolidPlug.vue?vue&type=script&lang=js"
export * from "./XIconSolidPlug.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidPlug.vue"]])

export default __exports__